module.exports = __webpack_public_path__ + "static/thumb-c9d7aee761ab770907d4cd338a40aeaa.png";